import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

export function withRouter(Component) {
  function WithRouterWrapper(props) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    return (
      <Component
        {...props}
        navigate={navigate}
        location={location}
        match={{ params }}
        history={{
          push: navigate,
          replace: (path) => navigate(path, { replace: true }),
        }}
      />
    );
  }

  WithRouterWrapper.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;
  return WithRouterWrapper;
}
